import type { FC, ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

interface EmptyStateProps {
    icon: LucideIcon
    title: string
    description?: ReactNode
    action?: ReactNode
    tone?: 'default' | 'success'
    className?: string
}

const EmptyState: FC<EmptyStateProps> = ({
    icon: Icon,
    title,
    description,
    action,
    tone = 'default',
    className
}): ReactNode => {
    return (
        <div className={cn('flex flex-col items-center justify-center gap-3 px-6 py-10 text-center', className)}>
            <div
                className={cn(
                    'flex size-11 items-center justify-center rounded-full',
                    tone === 'success' ? 'bg-success-soft text-success-ink' : 'bg-muted text-muted-foreground'
                )}
            >
                <Icon className='size-5' aria-hidden='true' />
            </div>

            <div className='flex max-w-sm flex-col gap-1'>
                <p className='text-sm font-semibold text-foreground'>
                    {title}
                </p>

                {description && (
                    <p className='text-sm text-muted-foreground text-pretty'>
                        {description}
                    </p>
                )}
            </div>

            {action && <div className='mt-1 flex flex-wrap items-center justify-center gap-2'>{action}</div>}
        </div>
    )
}

export default EmptyState
